import React from 'react'

const MagnifierIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0979 16.0979C16.6387 15.5572 17.5153 15.5572 18.0561 16.0979L23.5945 21.6364C24.1353 22.1771 24.1353 23.0538 23.5945 23.5945C23.0538 24.1353 22.1771 24.1353 21.6364 23.5945L16.0979 18.0561C15.5572 17.5153 15.5572 16.6387 16.0979 16.0979Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10.1538C0 4.54603 4.54603 0 10.1538 0C15.7616 0 20.3077 4.54603 20.3077 10.1538C20.3077 15.7616 15.7616 20.3077 10.1538 20.3077C4.54603 20.3077 0 15.7616 0 10.1538ZM10.1538 2.76923C6.07543 2.76923 2.76923 6.07543 2.76923 10.1538C2.76923 14.2322 6.07544 17.5385 10.1538 17.5385C14.2322 17.5385 17.5385 14.2322 17.5385 10.1538C17.5385 6.07544 14.2322 2.76923 10.1538 2.76923Z"
        />
      </g>
    </svg>
  )
}

export default MagnifierIcon
